import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';
import { Spinner, Container, Alert } from 'react-bootstrap';
import { useUserPermissions } from '../../contexts/UserPermissionsContext';

function AdminRoute({ children }) {
  const { isAuthenticated, isLoading: authLoading } = useAuth0();
  const {
    userPermissions,
    loading: permissionsLoading,
    isPending,
    isSuspended,
  } = useUserPermissions();

  if (authLoading || permissionsLoading) {
    return (
      <Container className="mt-5 text-center">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3">Loading...</p>
      </Container>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Check if account is pending
  if (isPending) {
    return (
      <Container className="mt-5">
        <Alert variant="warning">
          <Alert.Heading><><i className="bi bi-hourglass-split me-1"></i>Account Pending Approval</></Alert.Heading>
          <p>Your account is pending approval by an administrator.</p>
          <p>You will be notified once your account has been activated.</p>
          <hr />
          <p className="mb-0">
            Email: <strong>{userPermissions?.email}</strong>
          </p>
        </Alert>
      </Container>
    );
  }

  // Check if account is suspended
  if (isSuspended) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">
          <Alert.Heading><><i className="bi bi-x-circle-fill me-1"></i>Account Suspended</></Alert.Heading>
          <p>Your account has been suspended.</p>
          <p>Please contact an administrator for more information.</p>
        </Alert>
      </Container>
    );
  }

  // Check if user is admin
  if (userPermissions?.access_type !== 'admin') {
    return (
      <Container className="mt-5">
        <Alert variant="danger">
          <Alert.Heading><><i className="bi bi-lock-fill me-1"></i>Access Denied</></Alert.Heading>
          <p>You don't have permission to access this page.</p>
          <p>Only administrators can access this area.</p>
          <hr />
          <p className="mb-0">
            Your role: <strong>{userPermissions?.access_type || 'None'}</strong>
          </p>
        </Alert>
      </Container>
    );
  }

  return children;
}

export default AdminRoute;
